import React from "react";
import { Route, Switch } from "react-router-dom";
import { VinReportsList } from "./VinReports";

export default () => {
    return {
        routes: [
            {
                path: "/vin-reports",
                render: ({ match }) => (
                    <Switch>
                        <Route
                            path={`${match.url}`}
                            exact
                            component={VinReportsList}
                        />
                    </Switch>
                ),
            },
        ],
    };
};